// acciones
export const SAGA_GET_TIPOS_CONTENIDO = 'contenidoReducer/SAGA_GET_TIPOS_CONTENIDO'
export const SET_TIPOS_CONTENIDO = 'contenidoReducer/SET_TIPOS_CONTENIDO'

export const SAGA_GET_CONTENIDOS = 'contenidoReducer/SAGA_GET_CONTENIDOS'
export const SET_CONTENIDOS = 'contenidoReducer/SET_CONTENIDOS'
export const SET_CONTENIDOSBYID = 'contenidoReducer/SET_CONTENIDOSBYID'

export const SAGA_BORRAR_CONTENIDO = 'contenidoReducer/SAGA_BORRAR_CONTENIDO'
export const SET_CONTENIDO_INACTIVO = 'contenidoReducer/SET_CONTENIDO_INACTIVO'

export const SAGA_SAVE_CONTENIDO = 'contenidoReducer/SAGA_SAVE_CONTENIDO'

export const SAGA_SWAP_CONTENIDO = 'contenidoReducer/SAGA_SWAP_CONTENIDO'

export const SET_TIPO_CONTENIDO_SELECTED = 'contenidoReducer/SET_TIPO_CONTENIDO_SELECTED'

export const SAGA_PUT_CONTENIDOS = 'contenidoReducer/SAGA_PUT_CONTENIDOS'

export const SAGA_GET_CONTENIDOSBYID = 'contenidoReducer/SAGA_GET_CONTENIDOSBYID'

// funciones
export const setTipoContenidoSelected = (payload) =>({
    type: SET_TIPO_CONTENIDO_SELECTED,
    payload
})

export const sagaGetTiposContenido = () =>({
    type: SAGA_GET_TIPOS_CONTENIDO
})

export const setTiposContenido = (payload) =>({
    type: SET_TIPOS_CONTENIDO,
    payload
})

export const sagaGetContenido = (payload) =>({
    type: SAGA_GET_CONTENIDOS,
    payload
})

export const sagaGetContenidoById = (payload) =>{
    return {
    type: SAGA_GET_CONTENIDOSBYID,
    payload
}}

export const setContenidoById = (payload) =>{
return {
    type: SET_CONTENIDOSBYID,
    payload
}}

export const setContenido = (payload) =>({
    type: SET_CONTENIDOS,
    payload
})

export const sagaBorrarContenido = (payload) =>({
    type: SAGA_BORRAR_CONTENIDO,
    payload
})

export const setContenidoInactivo = (payload) =>({
    type: SET_CONTENIDO_INACTIVO,
    payload
})

export const sagaSabeContenido = (payload) =>({
    type: SAGA_SAVE_CONTENIDO,
    payload
})

export const sagaSwapContenido = (payload) =>({
    type: SAGA_SWAP_CONTENIDO,
    payload
})

export const sagaPutContenido = (payload) =>({
    type: SAGA_PUT_CONTENIDOS,
    payload
})